// eslint-disable-next-line
import { ApiConnector, GET } from './requestV2.service';
export default (() => {
    const API = ApiConnector('/report');
    const APIV2 = ApiConnector('/report', true);
    return {
        DownloadDocument: async data => await API(GET, '/download', false, data).call(false, false, 'blob'),
        DownloadDocumentByFileName: async fileName =>
                    await APIV2(GET, `/download/${fileName}`, false).call(false, false, 'blob'),
        GetStudentsReport: async (params) =>
            await APIV2(GET, '/students/report', false, params).call(),
    };
})();
